import { Box, Grid, Typography, Button } from "@mui/material";
import backgroundPost1 from "../../assets/account1.jpg";
import backgroundPost2 from "../../assets/novartis.jpeg";
import backgroundPost3 from "../../assets/background2.jpg";

import Feed from "../Feed/Feed";
import { ISAREL, POSTS_DB } from "../../utils/constant";
import { useState } from "react";
import CampaignPage from "../CampaignPage/CampaignPage";
import CampaignLogin from "../CampaignPage/CampaignLogin";

const MainSite = () => {
    const [source, setSource] = useState('');
    const renderDisplay = ()=> {
        switch(source){        
            case 'CampaignPage':
                return <CampaignPage userId="aa" />
            case 'NovoNardisc':
                return <Feed dataSource={{
                    dataBaseUrlParam:{
                      container:"novartis",
                      database:POSTS_DB,
                      query:"SELECT * FROM c WHERE IS_DEFINED(c.userAdded)"
                    }
                  } 
                }/>
            case 'AI_Convention':
                return <Feed dataSource={{
                    dataBaseUrlParam:{
                      container:"aiDemo",
                      database:POSTS_DB,
                      
                    }
                  } 
                }/>
            default:
                return (<>
                    <Typography variant="h4" style={{ textAlign: 'center', margin: '20px 0', fontWeight: 'bold' }}>
                        Available Campaigns
                    </Typography>
    
                    <Button variant="contained" color="primary" style={{ marginTop: '20px', fontWeight: 'bold' }}>
                        Add Campaign
                    </Button>
                    <Grid container spacing={2} style={{ justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                        <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'center' }}>
                            <Box sx={BoxStyle(backgroundPost1)} onClick={() => handleClick('CampaignPage')}>
                                <Typography sx={textStyle}>
                                    Israel Slingshot - מנצחים את מכונת השקר
                                </Typography>
                            </Box>
                        </Grid>
    
                        <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'center' }}>
                            <Box sx={BoxStyle(backgroundPost2)} onClick={() => handleClick('NovoNardisc')}>
                                <Typography sx={textStyle}>
                                    Novartis - Adderal Campaign
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12} sm={6} style={{ display: 'flex', justifyContent: 'center' }}>
                            <Box sx={BoxStyle(backgroundPost3)} onClick={() => handleClick('AI_Convention')}>
                                <Typography sx={textStyle}>
                                    Fight For Israel
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
    
                </> )

                
    }
    }
    const handleClick = (page:string) => {
        console.log('click');
        setSource(page);
    };

    const BoxStyle = (url: string) => ({
        position: 'relative',
        height: '500px',
        width: '500px',
        margin: '5px',
        backgroundImage: `url(${url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease', // Smooth transition for scale and shadow
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)', // Subtle shadow
        '&:hover': {
            transform: 'scale(1.05)',
            boxShadow: '0 8px 16px rgba(0,0,0,0.3)' // More prominent shadow on hover
        }
    });

    const textStyle = {
        color: 'white',
        textAlign: 'center',
        padding: '20px',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        borderRadius: '10px',
        cursor: 'pointer'
    };

    return (
            renderDisplay()
            )
        };

export default MainSite;